import {createActionGroup, props} from '@ngrx/store';
import {AppLayoutType} from '../../services/app-layout';

export const AppLayoutActions = createActionGroup({
	source: 'App / Layout',
	events: {
		'Set App Layout': props<{ layout: AppLayoutType }>(),
	}
});
